export const KlarnaIcon: React.FC<React.ComponentProps<"svg">> = ({
  ...props
}) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="28" height="28" fill="#FFB3C7" />
      <path
        d="M19.7025 6H16.1488C16.1548 7.42392 15.8255 8.82924 15.1876 10.1023C14.5498 11.3754 13.6213 12.4805 12.4772 13.3282L11.0708 14.3807L16.5148 21.8117H21L15.9855 14.9734C17.1693 13.7991 18.1076 12.4008 18.7458 10.8603C19.3839 9.31967 19.7091 7.66751 19.7025 6Z"
        fill="black"
      />
      <path d="M7 21.8117H10.6384V6H7V21.8117Z" fill="black" />
    </svg>
  );
};
